import plansData from '../../data/plans.json'

interface ContentfulPlanCategory {
  name: string
  type: string
}

interface ContentfulPlanColor {
  theme: string
  colourCode: string
}

export interface ContentfulPlan {
  contentfulId: string
  contentType: string
  id?: string
  category?: ContentfulPlanCategory
  planColor?: ContentfulPlanColor
  planColorPale?: ContentfulPlanColor
  name?: string
  title?: string
  description?: string
  slug?: string
  usesYellowAssets?: boolean
  data?: string
  dataDiscount?: string
  legacyFrom?: string
  chipColor?: string
}

export const getPlans = (): ContentfulPlan[] => {
  if (typeof plansData === 'undefined') {
    return []
  }
  return plansData as ContentfulPlan[]
}

export const getPlanBySlug = (slug: string): ContentfulPlan | undefined =>
  getPlans().find((plan) => plan.slug === slug)

export const getPlanById = (id: string): ContentfulPlan | undefined =>
  getPlans().find((plan) => plan.id === id)
